export default __webpack_public_path__ + "static/media/opening01.c6a708d3.jpg";